import { render } from "./CardViewPage.vue?vue&type=template&id=58667abd&ts=true"
import script from "./CardViewPage.vue?vue&type=script&lang=ts"
export * from "./CardViewPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__